// removed by extract-text-webpack-plugin
module.exports = {"link":"_1bBuL3izT7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PagesDrillDownTable/PagesDrillDownTable.scss
// module id = 898
// module chunks = 0